import { createStore } from "vuex";
import axios from 'axios';
import router from "@/router";
import jsCookie from 'js-cookie';

const store = createStore({
    state:{
        languageData:{
            availableLanguages: null,
            languageCode: jsCookie.get('languageCode') || navigator.language || navigator.userLanguage,
            languageArray: null,
            error: null
        },
        userCookies:{
            username: '',
            token: null,
            languageCode: null,
        },
        sessionData:{
            logInError: null,
            loggedIn: false
        },
        serverData:{
            backend: window.location == 'localhost:8080' ? 'localhost:8000' : 'https://pilousapi.poolingportal.com'
        },
        dashboardData:{
            orders: null,
            receipts: null,
            ownStock: null,
            buyStock: null,
            deliveryNote: null
        }
    },
    mutations:{
        setLanguageData(state, languageArr){
            state.languageData.languageArray = languageArr;
        },
        setLanguageCode(state, languageCo){
            state.languageData.languageCode = languageCo;
        },
        setUsername(state, username){
            state.userCookies.username = username;
        },
        setLanguageError(state, error){
            state.languageData.error = error;
        },
        setAvailableLanguages(state, possibilities){
            state.languageData.availableLanguages = possibilities;
        },
        setUserCookies(state, cookiesObject){
            for(var cookieName in cookiesObject){
                if(Object.prototype.hasOwnProperty.call(state.userCookies, cookieName)){
                    state.userCookies[cookieName] = cookiesObject[cookieName];
                }
            }
        },
        setLoggedIn(state, logged){
            state.sessionData.loggedIn = logged;
        },
        setLogInError(state, status){
            state.sessionData.logInError = status;
        },
        setDashboardOrders(state, array){
            state.dashboardData.orders = array;
        },
        setDashboardReceipts(state, array){
            state.dashboardData.receipts = array;
        },
        setDashboardOwnStock(state, array){
            state.dashboardData.ownStock = array;
        },
        setDashboardBuyStock(state, array){
            state.dashboardData.buyStock = array;
        },
        setDashboardDeliveryNote(state, array){
            state.dashboardData.deliveryNote = array;
        }
    },
    actions:{
        async getLanguageData({commit, state}){
            try{
                const response = await axios.post(`${state.serverData.backend}/api/language/${state.languageData.languageCode}`);
                if(!Object.hasOwn(response.data, 'welcome')){
                    commit('setLanguageCode', 'en-US');
                }
                commit('setLanguageData',response.data)
            }catch(error){
                commit('setLanguageError', error.message)
            }
        },
        async getAvailableLanguages({commit, state}){
            try{
                const response = await axios.post(`${state.serverData.backend}/api/language/options`);
                const sortedResponse = response.data.sort((a,b)=> a.name.localeCompare(b.name));
                commit('setAvailableLanguages', sortedResponse);
            }catch(error){
                commit('setLanguageError', error.message);
            }
        },
        initCookies({commit, dispatch}){
            const cookies = jsCookie.get();
            if(Object.hasOwn(cookies,'username') || Object.hasOwn(cookies,'token') || Object.hasOwn(cookies,'languageCode')){
                commit('setUserCookies',cookies);
            }
            if(Object.hasOwn(cookies,'username') || Object.hasOwn(cookies,'token')){
                dispatch('tryLogin');
            }
        },
        setUserCookies({commit}, cookiesObject){
            commit('setUserCookies',cookiesObject);
        },
        async logIn({commit}, cookiesObject){
            commit('setUserCookies',cookiesObject);
            this.dispatch('tryLogin');
        },
        setLogInError({commit, state}, errorKey){
            commit('setLogInError',state.languageData.languageArray[errorKey]);
        },
        async tryLogin({commit, state}){
            if(state.userCookies.username !== '' && state.userCookies.token !== 'null'){
                const response = await axios.post(`${state.serverData.backend}/api/login/token`,{
                    username:state.userCookies.username,
                    token:state.userCookies.token
                });
                if(response.data == 'OK'){
                    commit('setLoggedIn', true);
                    router.push('/dashboard');
                }else{
                    commit('setLogInError',state.languageData.languageArray[response.data.original.error]);
                }
            }
        },
        getLanguageFromCookies({commit}){
            const langCode = jsCookie.get('languageCode');
            if(langCode){
                commit('setUserCookies',{languageCode:langCode});
            }
        },
        setLanguageCode({commit}, languageCode){
            commit('setLanguageCode', languageCode);
        },
        async loadDashboardData({commit, state}){
                await axios.post(`${state.serverData.backend}/api/overview`,{username:state.userCookies.username,token:state.userCookies.token})
                .catch(() => {
                    commit('setLogInError','serverside_error');
                }).then((response) => {
                    console.log(response);
                    const dashboardData = response.data;
                    commit('setDashboardOrders',dashboardData.orders);
                    commit('setDashboardOwnStock',dashboardData.own_stock);
                    commit('setDashboardReceipts',dashboardData.receipts);
                    commit('setDashboardBuyStock',dashboardData.buy_stock);
                    commit('setDashboardDeliveryNote',dashboardData.delivery_note);
                });
        },
    }
});

store.watch(
    (state) => state.languageData.languageCode,
    (newValue, oldValue) => {
        if(newValue !== oldValue){
            store.dispatch('getLanguageData');
            store.dispatch('setUserCookies',{languageCode:newValue});
        }
    }
);

store.watch(
    (state) => state.userCookies,
    (newValue) => {
        Object.keys(newValue).forEach(key => {
            jsCookie.set(key, newValue[key], {expires:10});
        });
    },
    {deep:true}
);

store.watch(
    (state) => state.userCookies.logInError,
    () => {
        setTimeout(()=>{
            store.commit('setLogInError',null)
        }, 10000);
    }
);

export default store;